export default "__VITE_ASSET__B978tPhR__"